import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LegalNotice from './pages/LegalNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import EULA from './pages/EULA';
import { CookieProvider } from './contexts/CookieContext';
import { LanguageProvider } from './contexts/LanguageContext';
import CookieBanner from './components/CookieBanner';
import CookiePreferences from './components/CookiePreferences';
import CookieSettings from './components/CookieSettings';

function App() {
  return (
    <LanguageProvider>
      <CookieProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/legal-notice" element={<LegalNotice />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/eula" element={<EULA />} />
          </Routes>

          {/* Componentes de gestión de cookies */}
          <CookieBanner />
          <CookiePreferences />
          <CookieSettings />
        </div>
      </CookieProvider>
    </LanguageProvider>
  );
}

export default App; 